import { AnswerTypes, type InputListItem } from '@ifs-gcp/core/models';

import { AutocompleteAnswer, TextAnswer } from '@/components/audit/answers';
import { CheckboxAnswer } from '@/components/audit/answers/checkbox-answer';
import { RadioAnswer } from '@/components/audit/answers/radio-answer';
import type { AnswerProps } from '@/types/question';

interface AnswerPropsMap {
  [AnswerTypes.TEXT]: { value: string };
  [AnswerTypes.NUMBER]: { value: string };
  [AnswerTypes.TEXTAREA]: { value: string };
  [AnswerTypes.SELECT]: { value: string[] };
  [AnswerTypes.MULTI_SELECT]: { value: string[] };
  [AnswerTypes.LIST]: { value: InputListItem[] };
  [AnswerTypes.RADIO]: { value: string };
  [AnswerTypes.CHECKBOX]: { value: string[] };
  [AnswerTypes.DATE]: { value: string };
  [AnswerTypes.YEAR]: { value: string };
}

type AnswerComponentType<K extends keyof AnswerPropsMap> = React.FC<
  AnswerProps<AnswerPropsMap[K]['value']>
>;

export type AnswerVariant<K extends keyof AnswerPropsMap = keyof AnswerPropsMap> = {
  [T in K]: { type: T; props: AnswerPropsMap[T] };
}[K];

export const ANSWER_COMPONENTS: {
  [K in keyof AnswerPropsMap]?: AnswerComponentType<K>;
} = {
  [AnswerTypes.TEXT]: TextAnswer,
  [AnswerTypes.NUMBER]: TextAnswer,
  [AnswerTypes.TEXTAREA]: TextAnswer,
  [AnswerTypes.SELECT]: AutocompleteAnswer,
  [AnswerTypes.MULTI_SELECT]: AutocompleteAnswer,
  [AnswerTypes.CHECKBOX]: CheckboxAnswer,
  [AnswerTypes.RADIO]: RadioAnswer,
};
